import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SearchServiceComponent } from './pages/search-service/search-service.component';
import { SelfDiagnosticStepComponent } from './pages/self-diagnostic-step/self-diagnostic-step.component';
import { RateComponent } from './pages/rate/rate.component';
import { ServiceCatalogComponent } from './pages/service-catalog/service-catalog.component';

const routes: Routes = [
  {
    path: '',
    component: ServiceCatalogComponent,
  },
  {
    path: 'self-diagnostic-step/:selfDiagnosisId',
    component: SelfDiagnosticStepComponent,
  },
  {
    path: 'rate',
    component: RateComponent,
  },
  {
    path: 'service-catalog',
    component: ServiceCatalogComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SelfDiagnosticRoutingModule {}
